export default class Ui
{
    
    constructor( core )
    {
        if ( !Ui.instance ) {
            this.logger = core.getLogger()
            this.uuid = core.getUuid()
            this.eventManager = core.getEventManager()
            Ui.instance = this
        }
        return Ui.instance
    }
    
    simpleModalDialog( title, text )
    {
        
        return new Promise( ( resolve, reject ) =>
        {
            
            let modalUuid = this.uuid.generate()
            
            this.eventManager.add( 'on-modal-approve-' + modalUuid, () =>
            {
                this.eventManager.remove( 'on-modal-cancel-' + modalUuid )
                return resolve()
            } )
            
            this.eventManager.add( 'on-modal-cancel-' + modalUuid, () =>
            {
                this.eventManager.remove( 'on-modal-approve-' + modalUuid )
                return reject()
            } )
            
            this.eventManager.dispatch( 'on-modal-dialog', {
                title:     title,
                text:      text,
                mode:      'simple',
                modalUuid: modalUuid
            } )
            
            
        } )
        
    }
    
    showInfoScreen( which )
    {
        this.eventManager.dispatch( 'on-show-info-screen', which )
    }
    
    showUserProfile( which )
    {
        this.eventManager.dispatch( 'on-show-user-profile', which )
    }
    
}